import axios from 'axios';
import constants from '@/constants';

let instance = axios.create({
    baseURL: constants.cmsApi,
});

export default instance;
